import { getMessages } from '../../../../../../store/constants';

export const CLASS_NOTIFICATIONS_REQUEST = 'notifications-request-dialog';

export const NOTIFICATIONS_REQUEST_TITLE = getMessages().getText('notifications_request.title');
export const NOTIFICATIONS_REQUEST_LABEL_NOT_NOW = getMessages().getText('notifications_request.not_now');
export const NOTIFICATIONS_REQUEST_LABEL_GOT_IT = getMessages().getText('notifications_request.got_it');

export const BROWSER_NOTIFICATIONS_REQUEST_ACTION_DATE_KEY = 'NOTIFICATIONS_REQUEST_ACTION_DATE';
